import simplify from 'simplify-js';

/**
 * Reduce a polygon ring to at most `maxPoints` vertices using Douglas–Peucker
 * (simplify-js). The tolerance is auto-escalated until the cap is met, so a huge
 * Nominatim boundary (hundreds of vertices) collapses to a light outline while a
 * small ring passes through untouched. Coordinates are GeoJSON `[lng, lat]`; the
 * ring is returned closed (first === last).
 */
export function simplifyRing(ring: number[][], maxPoints = 64): number[][] {
  if (ring.length <= maxPoints) return ring;

  const pts = ring.map(([x, y]) => ({ x, y }));
  let tolerance = 1e-4; // ~10m at the equator
  let out = pts;
  for (let i = 0; i < 14 && out.length > maxPoints; i++) {
    out = simplify(pts, tolerance, true); // highQuality Douglas–Peucker
    tolerance *= 1.7;
  }

  const result = out.map((p) => [p.x, p.y]);
  const first = result[0];
  const last = result[result.length - 1];
  if (first && last && (first[0] !== last[0] || first[1] !== last[1])) {
    result.push([first[0], first[1]]); // keep the ring closed
  }
  return result;
}
